module.exports = __webpack_public_path__ + "src/assets/games/27/929.jpg";